import React, {useEffect, useLayoutEffect, useMemo, useState} from 'react';
import {useMacro} from "../../../components/hooks";
import {useTranslation} from "react-i18next";
import {FormProvider, useForm} from "react-hook-form";
import {inventoryPolicies, macroPolicies} from "../../../helpers";
import {Backdrop, Button, CircularProgress, Grid, Paper, Typography} from "@mui/material";
import {FormMonacoEditor, HeadlinePage} from "../../../components/common";
import {Input} from "../../../components/layout";
import {useStyle} from "./styles";
import { withPermission } from 'hoc';

const MacroFormDumb = ({defaultValues, handleExecute, fieldData, validPermission}) => {

  const { isLoaded, getExecuteFileData, data } = useMacro()
  const [t] = useTranslation();
  const classes = useStyle();
  const [ selectedType , setSelectedType] = useState('Create');
  const types = [
    {value: 'create', label: 'Create'},
    {value: 'execute', label: 'Execute'}
  ]
  const methods = useForm({
    defaultValues: useMemo(() => {
      return defaultValues;
    }, [defaultValues])
  });
  const {
    handleSubmit,
    control,
    setValue,
    setError
  } = methods;

  useEffect(() => {
    setSelectedType(defaultValues.type);
  }, [defaultValues]);

  useEffect(() => {
    if (data) {
      setValue(macroPolicies.configFile.name, data.data);
    }
  }, [data]);

  const handleOnChangeType = (event) => {
    setValue(macroPolicies.configFile.name, '');
    setValue(macroPolicies.name.name, '');
    setSelectedType(event.target.value);
  }

  const handleOnChangeFileSelected = (event) => {
    const filename = event.target.value;
    setValue(macroPolicies.name.name, filename.substring(0, filename.lastIndexOf(".")));
    getExecuteFileData({query: { filename: filename}});
  }

  const execute = (data) => {
    if (data.inventory.trim() === '') {
      setError(macroPolicies.inventory.name, {message: t('macro.form.error.inventory')});
      return;
    }
    if (data.credential === '') {
      setError(macroPolicies.credential.name, {message: t('macro.form.error.credential')});
      return;
    }
    handleExecute(data);
  }

  const fields = [
    { policy: macroPolicies.name, disabled: selectedType !== 'create'},
    { policy: macroPolicies.description, disabled: false},
    { policy: macroPolicies.inventory, options: fieldData.inventories, isLoaded, enabledLanguage: false, disabled: false},
    { policy: macroPolicies.hosts, disabled: false},
    { policy: macroPolicies.credential, options: fieldData.credentials, isLoaded, enabledLanguage: false, disabled: false},
  ];

  return (
    <>
      <Backdrop
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoaded.post}
      >
        <CircularProgress color="primary" />
      </Backdrop>

      <HeadlinePage title={'macro.headline'}/>
      <FormProvider { ...methods }>
        <Paper className={classes.paperStyle}>
          <form>
            <Typography variant="h6" sx={{ padding: '8px 0px' }}>
              {t('macro.form.title')}
            </Typography>

            <Grid container spacing={2} sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              mb: 1
            }}>

              {fields.map((field) => (
                <Grid item xs={12} sm={12} md={6} lg={4} key={field.policy.id}>
                  <Input
                    {...field.policy}
                    control={control}
                    options={field.options}
                    sx={{ width: '100%' }}
                    disabled ={field.disabled}
                  />
                </Grid>
              ))}

              <Grid item xs={12} sm={12} md={6} lg={4} key={macroPolicies.type.id}>
                <Input
                  { ...macroPolicies.type }
                  control={ control }
                  options={ types }
                  sx={{ width: '100%' }}
                  onChange = {handleOnChangeType}
                />
              </Grid>

              { (selectedType === 'execute') &&
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Input
                    { ...macroPolicies.configFileSelect }
                    control={ control }
                    options={ fieldData.configFiles }
                    sx={{ width: '100%' }}
                    onChange = {handleOnChangeFileSelected}
                  />
                </Grid>
              }

              <Grid item xs={12} sm={12} md={12} lg={12}>
                <FormMonacoEditor
                  label={macroPolicies.configFile.label}
                  name={macroPolicies.configFile.name}
                  helperText={macroPolicies.configFile.helperText}
                  methods={methods}
                  language={'yaml'}
                  height='200px'
                  acceptedFormats = {['yaml']}
                />
              </Grid>
            </Grid>

            {validPermission(-1, 'isExecute')?<Grid container sx={{ mt: 4 }}>
              <Grid item md={2} lg={3} />
              <Grid item xs={12} sm={12} md={8} lg={6}>
                <Button variant="contained" sx={{ width: '100%' }} onClick={handleSubmit(execute)}>
                  { t('macro.components.submit')}
                </Button>
              </Grid>
              <Grid item md={2} lg={3} />
            </Grid>:null}
          </form>
        </Paper>
      </FormProvider>
    </>
  );
}

export default withPermission(MacroFormDumb, "macros");